import React from 'react';
import { AlertTriangle, CheckCircle, Clock, ChevronRight } from 'lucide-react';


const statusConfig = {
  a_jour: { label: 'À jour', icon: CheckCircle, cls: 'text-green-600 bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800' },
  dette_en_cours: { label: 'Dette en cours', icon: Clock, cls: 'text-orange-600 bg-orange-50 dark:bg-orange-900/20 border-orange-200 dark:border-orange-800' },
  retard: { label: 'Retard', icon: AlertTriangle, cls: 'text-red-600 bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800' },
};

export default function PartnerSummaryTable({ data, loading, onSelectProvider }) {
  if (loading) {
    return (
      <div className="space-y-3">
        {[1, 2, 3]?.map(i => (
          <div key={i} className="h-16 bg-gray-100 dark:bg-slate-700 rounded-xl animate-pulse" />
        ))}
      </div>
    );
  }

  if (!data?.length) {
    return (
      <div className="text-center py-12 text-gray-400 dark:text-gray-500">
        <p className="text-sm">Aucune opération partenaire enregistrée</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-200 dark:border-slate-700">
            <th className="text-left py-3 px-4 font-semibold text-gray-600 dark:text-gray-400">Prestataire</th>
            <th className="text-right py-3 px-4 font-semibold text-gray-600 dark:text-gray-400">Opérations</th>
            <th className="text-right py-3 px-4 font-semibold text-gray-600 dark:text-gray-400">Encaissé</th>
            <th className="text-right py-3 px-4 font-semibold text-gray-600 dark:text-gray-400">Part prestataire</th>
            <th className="text-right py-3 px-4 font-semibold text-gray-600 dark:text-gray-400">Dû à ADT</th>
            <th className="text-right py-3 px-4 font-semibold text-gray-600 dark:text-gray-400">Déjà reversé</th>
            <th className="text-right py-3 px-4 font-semibold text-gray-600 dark:text-gray-400">Solde restant</th>
            <th className="text-center py-3 px-4 font-semibold text-gray-600 dark:text-gray-400">Statut</th>
            <th className="py-3 px-4" />
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 dark:divide-slate-700">
          {data?.map(row => {
            const cfg = statusConfig?.[row?.globalStatus] || statusConfig?.a_jour;
            const StatusIcon = cfg?.icon;
            return (
              <tr
                key={row?.providerId || row?.providerName}
                className="hover:bg-gray-50 dark:hover:bg-slate-700/50 cursor-pointer transition-colors"
                onClick={() => onSelectProvider?.(row)}
              >
                <td className="py-3 px-4 font-medium text-gray-900 dark:text-white">
                  {row?.providerName}
                </td>
                <td className="py-3 px-4 text-right text-gray-600 dark:text-gray-400">
                  {row?.operationCount}
                </td>
                <td className="py-3 px-4 text-right font-medium text-gray-900 dark:text-white">
                  {row?.totalCollected?.toFixed(2)}€
                </td>
                <td className="py-3 px-4 text-right text-orange-600">
                  {row?.totalPartnerShare?.toFixed(2)}€
                </td>
                <td className="py-3 px-4 text-right text-blue-600 font-medium">
                  {row?.totalDueToAdt?.toFixed(2)}€
                </td>
                <td className="py-3 px-4 text-right text-green-600">
                  {row?.totalReversed?.toFixed(2)}€
                </td>
                <td className="py-3 px-4 text-right font-bold text-gray-900 dark:text-white">
                  {row?.remainingBalance?.toFixed(2)}€
                </td>
                <td className="py-3 px-4 text-center">
                  <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border ${cfg?.cls}`}>
                    <StatusIcon className="h-3 w-3" />
                    {cfg?.label}
                  </span>
                </td>
                <td className="py-3 px-4">
                  <ChevronRight className="h-4 w-4 text-gray-400" />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
